import { z } from 'zod';

export const FeedbackType = z.enum(['BUG', 'FEATURE', 'IMPROVEMENT', 'OTHER']);
export type FeedbackType = z.infer<typeof FeedbackType>;

export const FeedbackStatus = z.enum(['OPEN', 'PLANNED', 'IN_PROGRESS', 'DONE', 'REJECTED']);
export type FeedbackStatus = z.infer<typeof FeedbackStatus>;

export const FeedbackPriority = z.enum(['LOW', 'MEDIUM', 'HIGH']);
export type FeedbackPriority = z.infer<typeof FeedbackPriority>;

export const FeedbackDTO = z.object({
  id: z.string(),
  type: FeedbackType,
  title: z.string(),
  body: z.string(),
  status: FeedbackStatus,
  priority: FeedbackPriority,
  pageUrl: z.string().nullable(),
  adminNote: z.string().nullable(),
  hasScreenshot: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  // nur in der Admin-Liste gefüllt
  authorName: z.string().nullable().optional(),
  authorEmail: z.string().nullable().optional(),
});
export type FeedbackDTO = z.infer<typeof FeedbackDTO>;

export const FeedbackDetailDTO = FeedbackDTO.extend({
  screenshotDataUrl: z.string().nullable(),
});
export type FeedbackDetailDTO = z.infer<typeof FeedbackDetailDTO>;

export const FeedbackCreateInput = z.object({
  type: FeedbackType.optional(),
  title: z.string().trim().min(1).max(200),
  body: z.string().trim().max(5000).optional(),
  pageUrl: z.string().max(500).optional(),
  // data:image/png;base64,... – max. ~5 MB Rohbild
  screenshotDataUrl: z.string().max(8_000_000).optional(),
});
export type FeedbackCreateInput = z.infer<typeof FeedbackCreateInput>;

export const FeedbackUpdateInput = z.object({
  status: FeedbackStatus.optional(),
  priority: FeedbackPriority.optional(),
  adminNote: z.string().max(5000).nullable().optional(),
});
export type FeedbackUpdateInput = z.infer<typeof FeedbackUpdateInput>;

export const FeedbackListQuery = z.object({
  status: FeedbackStatus.optional(),
  type: FeedbackType.optional(),
  q: z.string().optional(),
});
export type FeedbackListQuery = z.infer<typeof FeedbackListQuery>;

export const FeedbackListResponse = z.object({ feedback: z.array(FeedbackDTO) });
export type FeedbackListResponse = z.infer<typeof FeedbackListResponse>;

export const FeedbackResponse = z.object({ feedback: FeedbackDTO });
export type FeedbackResponse = z.infer<typeof FeedbackResponse>;

export const FeedbackDetailResponse = z.object({ feedback: FeedbackDetailDTO });
export type FeedbackDetailResponse = z.infer<typeof FeedbackDetailResponse>;

export const FeedbackStatsResponse = z.object({
  total: z.number(),
  open: z.number(),
  inProgress: z.number(),
  done: z.number(),
  byType: z.object({
    BUG: z.number(),
    FEATURE: z.number(),
    IMPROVEMENT: z.number(),
    OTHER: z.number(),
  }),
});
export type FeedbackStatsResponse = z.infer<typeof FeedbackStatsResponse>;
